import { companyToday, dayKeyInTz, todayInTz } from '@/lib/companyTime';

const ORDER = ['Today', 'Yesterday', 'Earlier this week', 'Older'];

// Recent activity on the company's calendar: Today / Yesterday / Earlier this week (weeks start Sunday) / Older.
export function groupRecents(items, tz) {
  const today = todayInTz(0, tz);
  const yesterday = todayInTz(-1, tz);
  const weekStart = todayInTz(-companyToday(tz).getDay(), tz);
  const labelOf = (r) => {
    const d = dayKeyInTz(r.opened_at, tz);
    if (d === today) return 'Today';
    if (d === yesterday) return 'Yesterday';
    return d >= weekStart ? 'Earlier this week' : 'Older';
  };
  const by = {};
  items.forEach((r) => { (by[labelOf(r)] ||= []).push(r); });
  return ORDER.filter((k) => by[k]).map((label) => ({ label, items: by[label] }));
}

// Typing filters recent activity at once (type, title and subtitle).
export const matchRecent = (r, q) => !q || `${r.type_title} ${r.title} ${r.subtitle || ''}`.toLowerCase().includes(q.toLowerCase());
